"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var React = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components")); // use custom props like below - that way we would not put unknown props to the DOM


exports.ButtonContainer = styled_components_1.default(function (_a) {
  var isSelected = _a.isSelected,
      activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["isSelected", "activeBreakpoint"]);

  return React.createElement(react_native_1.TouchableOpacity, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid rgba(146, 152, 161, 0.4);\n    border-radius: 8px;\n    padding: 16px;\n    ", "\n"], ["\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid rgba(146, 152, 161, 0.4);\n    border-radius: 8px;\n    padding: 16px;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      theme = _a.theme,
      isSelected = _a.isSelected;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            flex: 0 0\n            " + (small ? '90%' : '300px') + ";\n            margin: 0\n                " + (small ? '8px' : '26px') + "\n                8px \n                0;\n            padding-top: " + (small ? '11px' : '17px') + ";\n            padding-bottom: " + (small ? '11px' : '15px') + ";\n            background-color: " + (isSelected ? theme.colors.secondary.orange : theme.colors.buttonText) + ";\n            box-shadow: " + (isSelected ? 'none' : '1px 2px 4px rgba(0, 0, 0, 0.14), -1px 2px 4px rgba(0, 0, 0, 0.14)') + ";\n        ";
});
exports.ButtonText = styled_components_1.default(function (_a) {
  var isSelected = _a.isSelected,
      rest = __rest(_a, ["isSelected"]);

  return React.createElement(react_native_1.Text, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 18px;\n    color: ", ";\n    font-family: Roboto;\n    font-weight: bold;\n    line-height: 28px;\n"], ["\n    font-size: 18px;\n    color: ", ";\n    font-family: Roboto;\n    font-weight: bold;\n    line-height: 28px;\n"])), function (_a) {
  var isSelected = _a.isSelected,
      theme = _a.theme;
  return isSelected ? theme.colors.buttonText : theme.colors.dark;
});
exports.InnerCircle = styled_components_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var theme = _a.theme;
  return "\n        height: 8px;\n        width: 8px;\n        border-radius: 10px;\n        border: 1px solid " + theme.colors.secondary.orange + ";\n        background-color: " + theme.colors.secondary.orange + ";\n    ";
});
exports.CircleActive = styled_components_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var theme = _a.theme;
  return "\n            margin-left: 16px;\n            height: 18px;\n            width: 18px;\n            padding: 4px;\n            border: 1px solid " + theme.colors.secondary.orange + ";\n            border-radius: 10px;\n            background-color: " + theme.colors.buttonText + ";\n    ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;